import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  getClients(params) {
    return axios.get(adminPath('/clients?') + prepareQueryString(params)).then((response) => {
      return {
        clients: response.data.map((client) => an('Client', client)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  get(id) {
    return axios.get(adminPath(`/clients/${id}`)).then((response) => an('Client', response.data));
  },
  update(id, data) {
    return axios
      .patch(adminPath(`/clients/${id}`), {
        ...data,
      })
      .then((response) => an('Client', response.data));
  },
  create(data) {
    return axios
      .post(adminPath('/clients'), {
        ...data,
      })
      .then((response) => an('Client', response.data));
  },
  getSpreadsheet(params) {
    return axios.get(adminPath('/clients.csv?') + prepareQueryString(params), { responseType: 'blob' });
  },
  getInvoiceDeliveryMethodOptions() {
    return axios.get(adminPath('/clients/invoice_delivery_method_options'));
  },
};
